import { IconButton } from '@mui/material';
import styled from 'styled-components';

export const StyledIconButton = styled(IconButton)`
  && {
    padding: 0px;
    margin: 0 0px;
  }
`;
